import React from "react"
import PropTypes from "prop-types"
import PaymentAmountTextInput from "./payment_amount_text_input"
import PaymentOptionRadioInput from "./payment_option_radio_input"
import RegistrationsPropTypes from "utils/prop_types"
import { centsToFormatted } from "utils/money"

class PaymentAmountOption extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onOtherAmountChange: PropTypes.func,
    paymentAmount: RegistrationsPropTypes.PaymentAmount.isRequired,
    selected: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { onOtherAmountChange, onChange, selected, paymentAmount } = this.props
    const { allowTextInput, amountCents, currency, id } = paymentAmount
    const value = amountCents.toString()

    return (
      <PaymentOptionRadioInput
        {...{ allowTextInput, selected }}
        id={`payment_amount-${id}`}
        name="payment_amount"
        onChange={onChange}
        value={value}
      >
        {this.getInputText()}

        {selected && allowTextInput && (
          <div>
            <div className="ml-1">
              <PaymentAmountTextInput
                amountCents={amountCents}
                currency={currency}
                onChange={onOtherAmountChange}
              />
            </div>
          </div>
        )}
      </PaymentOptionRadioInput>
    )
  }

  getInputText = () => {
    const { allowTextInput, amountCents, currency, description } = this.props.paymentAmount

    if (amountCents === 0 || allowTextInput) {
      return description
    } else {
      return `${description} - ${centsToFormatted(amountCents, currency)}`
    }
  }
}

export default PaymentAmountOption
